function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5625 7.34286H18.1875C18.4983 7.34286 18.75 7.09354 18.75 6.78571V4.55714C18.75 4.24932 18.4983 4 18.1875 4H3.5625C3.25172 4 3 4.24932 3 4.55714V6.78571C3 7.09354 3.25172 7.34286 3.5625 7.34286ZM20.4375 10.1286H5.8125C5.50172 10.1286 5.25 10.3779 5.25 10.6857V12.9143C5.25 13.2221 5.50172 13.4714 5.8125 13.4714H20.4375C20.7483 13.4714 21 13.2221 21 12.9143V10.6857C21 10.3779 20.7483 10.1286 20.4375 10.1286ZM18.1875 16.2571H3.5625C3.25172 16.2571 3 16.5065 3 16.8143V19.0429C3 19.3507 3.25172 19.6 3.5625 19.6H18.1875C18.4983 19.6 18.75 19.3507 18.75 19.0429V16.8143C18.75 16.5065 18.4983 16.2571 18.1875 16.2571Z",
  fill: "#424240"
});

var SvgStream = function SvgStream(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStream, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Stream.543e3039.svg";
export { ForwardRef as ReactComponent };